const isMobile = () => {
  return window.__g_isMobile;
};
const isHorizontal = () => {
  //window.screen.orientation.angle
  return window.orientation % 180 == 90;
};
export { isMobile, isHorizontal };